/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  PayableOverrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PaymentSplitter,
  PaymentSplitterInterface,
} from "../PaymentSplitter";

const _abi = [
  {
    inputs: [],
    stateMutability: "payable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ERC20PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payeeCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type PaymentSplitterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PaymentSplitterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PaymentSplitter__factory extends ContractFactory {
  constructor(...args: PaymentSplitterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): Promise<PaymentSplitter> {
    return super.deploy(overrides || {}) as Promise<PaymentSplitter>;
  }
  getDeployTransaction(
    overrides?: PayableOverrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): PaymentSplitter {
    return super.attach(address) as PaymentSplitter;
  }
  connect(signer: Signer): PaymentSplitter__factory {
    return super.connect(signer) as PaymentSplitter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PaymentSplitterInterface {
    return new utils.Interface(_abi) as PaymentSplitterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PaymentSplitter {
    return new Contract(address, _abi, signerOrProvider) as PaymentSplitter;
  }
}
